module.exports = __webpack_public_path__ + "img/logo2.5d996ca6.png";